<template>
  <v-carousel
    v-model="currentSlide"
    height="100%"
    hide-delimiters
    show-arrows-on-hover
    cycle
    :interval="15000"
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
    >
      <div class="d-flex fill-height justify-center align-center">
        <SpeedsChart v-if="currentSlide === 0" />
        <GeneralDataCard v-if="currentSlide === 1" />
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import GeneralDataCard from "./voyage_data/GeneralDataCard.vue";
import SpeedsChart from "./SpeedsChart.vue";
export default {
  name: "VesselCarousel",
  components: {
    GeneralDataCard,
    SpeedsChart,
  },
  data() {
    return {
      currentSlide: 0,
      slides: ["speed_chart", "voyage_data_card"],
    };
  },
};
</script>

<style scoped>
.v-carousel {
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
